import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import css from "./index.module.scss";
import MobileContext from "../../context.js";
import i18n from "i18next";

const timeList = [
  "2021-至今",
  "2018-2020",
  "2015-2017",
  "2008-2014",
  "2004-2007",
  "2000-2003",
  "1998-1999",
  "1996-1997",
  "1994-1995",
  "1992-1993",
];

function Index() {
  const { t } = useTranslation();
  const sizeH = 250;
  const mobile = useContext(MobileContext);
  const listRef = useRef([]);
  const xScrollel = useRef(null);
  const [scrollListU, setScrollList] = useState([]);
  const [lng, SetLng] = useState("zh");

  if (i18n.language !== lng) {
    SetLng(i18n.language);
  }

  const scrollel = useRef(null);

  const ref0 = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);
  const ref9 = useRef(null);

  const [tabIndex, setTabIndex] = useState(0);

  const getRef = (dom) => {
    listRef.current.push(dom);
  };

  useEffect(() => {
    const scrollList = [];
    scrollList.push(ref0.current && ref0.current.offsetTop);
    scrollList.push(ref1.current && ref1.current.offsetTop);
    scrollList.push(ref2.current && ref2.current.offsetTop);
    scrollList.push(ref3.current && ref3.current.offsetTop);
    scrollList.push(ref4.current && ref4.current.offsetTop);
    scrollList.push(ref5.current && ref5.current.offsetTop);
    scrollList.push(ref6.current && ref6.current.offsetTop);
    scrollList.push(ref7.current && ref7.current.offsetTop);
    scrollList.push(ref8.current && ref8.current.offsetTop);
    scrollList.push(ref9.current && ref9.current.offsetTop);
    setScrollList(scrollList);
  }, [lng]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!mobile) {
      scrollel.current.scrollTop = tabIndex * sizeH;
    } else {
      // console.log(listRef.current[tabIndex].offsetLeft);
      xScrollel.current.scrollLeft = listRef.current[tabIndex].offsetLeft - 20;
      scrollel.current.scrollTop = scrollListU[tabIndex];
    }
  }, [tabIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  const addIndex = () => {
    let temp = tabIndex;
    setTabIndex(temp === 9 ? 9 : temp + 1);
  };
  const minusIndex = () => {
    let temp = tabIndex;
    setTabIndex(temp === 0 ? 0 : temp - 1);
  };
  const getTop = (index) => {
    return index * sizeH + 80;
  };

  return (
    <div className={css.container}>
      <div className={css.title}>{t("$singlee_ab_md3")}</div>
      <div className={css.tabzone}>
        <div className={css.larrow} onClick={minusIndex}>
          <div className={css.img}></div>
        </div>

        {mobile ? (
          <div className={css.mtabs} ref={xScrollel}>
            {timeList.map((item, index) => {
              return (
                <div
                  className={`${css.mtab} ${
                    tabIndex === index ? css.select : ""
                  }`}
                  ref={getRef}
                  onClick={() => setTabIndex(index)}
                  key={index}
                >
                  {t(item)}
                </div>
              );
            })}
          </div>
        ) : (
          <div className={css.tabs}>
            <div
              className={`${css.tab} ${tabIndex === 0 ? css.select : ""}`}
              onClick={() => setTabIndex(0)}
            >
              {t("2021-至今")}
            </div>
            <div
              className={`${css.tab} ${tabIndex === 1 ? css.select : ""}`}
              onClick={() => setTabIndex(1)}
            >
              2018-2020
            </div>
            <div
              className={`${css.tab} ${tabIndex === 2 ? css.select : ""}`}
              onClick={() => setTabIndex(2)}
            >
              2015-2017
            </div>
            <div
              className={`${css.tab} ${tabIndex === 3 ? css.select : ""}`}
              onClick={() => setTabIndex(3)}
            >
              2008-2014
            </div>
            <div
              className={`${css.tab} ${tabIndex === 4 ? css.select : ""}`}
              onClick={() => setTabIndex(4)}
            >
              2004-2007
            </div>
            <div
              className={`${css.tab} ${tabIndex === 5 ? css.select : ""}`}
              onClick={() => setTabIndex(5)}
            >
              2000-2003
            </div>
            <div
              className={`${css.tab} ${tabIndex === 6 ? css.select : ""}`}
              onClick={() => setTabIndex(6)}
            >
              1998-1999
            </div>
            <div
              className={`${css.tab} ${tabIndex === 7 ? css.select : ""}`}
              onClick={() => setTabIndex(7)}
            >
              1996-1997
            </div>
            <div
              className={`${css.tab} ${tabIndex === 8 ? css.select : ""}`}
              onClick={() => setTabIndex(8)}
            >
              1994-1995
            </div>
            <div
              className={`${css.tab} ${tabIndex === 9 ? css.select : ""}`}
              onClick={() => setTabIndex(9)}
            >
              1992-1993
            </div>
          </div>
        )}

        <div className={css.rarrow} onClick={addIndex}>
          <div className={css.imgr}></div>
        </div>
      </div>
      <div className={css.window} ref={scrollel}>
        {mobile ? (
          <div className={css.scrollMobile}>
            <div className={css.right}>
              <div
                ref={ref0}
                className={`${css.rightitem} ${
                  tabIndex === 0 ? css.select : ""
                }`}
                onClick={() => setTabIndex(0)}
              >
                <div className={css.title}>{t("2021-至今")}</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs1")}</div>
                  <div className={css.details}>{t("$singlee_hs2")}</div>
                  <div className={css.details}>{t("$singlee_hs3")}</div>
                  <div className={css.details}>{t("$singlee_hs4")}</div>
                  <div className={css.details}>{t("$singlee_hs5")}</div>
                  <div className={css.details}>{t("$singlee_hs6")}</div>
                  <div className={css.details}>{t("$singlee_hs7")}</div>
                  <div className={css.details}>{t("$singlee_hs8")}</div>
                  <div className={css.details}>{t("$singlee_hs9")}</div>
                </div>
              </div>
              <div
                ref={ref1}
                className={`${css.rightitem} ${
                  tabIndex === 1 ? css.select : ""
                }`}
                onClick={() => setTabIndex(1)}
              >
                <div className={css.title}>2018-2020</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs10")}</div>
                  <div className={css.details}>{t("$singlee_hs11")}</div>
                  <div className={css.details}>{t("$singlee_hs12")}</div>
                  <div className={css.details}>{t("$singlee_hs13")}</div>
                  <div className={css.details}>{t("$singlee_hs14")}</div>
                </div>
              </div>
              <div
                ref={ref2}
                className={`${css.rightitem} ${
                  tabIndex === 2 ? css.select : ""
                }`}
                onClick={() => setTabIndex(2)}
              >
                <div className={css.title}>2015-2017</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs15")}</div>
                  <div className={css.details}>{t("$singlee_hs16")}</div>
                  <div className={css.details}>{t("$singlee_hs17")}</div>
                </div>
              </div>
              <div
                ref={ref3}
                className={`${css.rightitem} ${
                  tabIndex === 3 ? css.select : ""
                }`}
                onClick={() => setTabIndex(3)}
              >
                <div className={css.title}>2008-2014</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs18")}</div>
                  <div className={css.details}>{t("$singlee_hs19")}</div>
                  <div className={css.details}>{t("$singlee_hs20")}</div>
                  <div className={css.details}>{t("$singlee_hs21")}</div>
                </div>
              </div>
              <div
                ref={ref4}
                className={`${css.rightitem} ${
                  tabIndex === 4 ? css.select : ""
                }`}
                onClick={() => setTabIndex(4)}
              >
                <div className={css.title}>2004-2007</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs22")}</div>
                  <div className={css.details}>{t("$singlee_hs23")}</div>
                  <div className={css.details}>{t("$singlee_hs24")}</div>
                </div>
              </div>
              <div
                ref={ref5}
                className={`${css.rightitem} ${
                  tabIndex === 5 ? css.select : ""
                }`}
                onClick={() => setTabIndex(5)}
              >
                <div className={css.title}>2000-2003</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs25")}</div>
                  <div className={css.details}>{t("$singlee_hs26")}</div>
                  <div className={css.details}>{t("$singlee_hs27")}</div>
                  <div className={css.details}>{t("$singlee_hs28")}</div>
                </div>
              </div>
              <div
                ref={ref6}
                className={`${css.rightitem} ${
                  tabIndex === 6 ? css.select : ""
                }`}
                onClick={() => setTabIndex(6)}
              >
                <div className={css.title}>1998-1999</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs29")}</div>
                  <div className={css.details}>{t("$singlee_hs30")}</div>
                  <div className={css.details}>{t("$singlee_hs31")}</div>
                  <div className={css.details}>{t("$singlee_hs32")}</div>
                </div>
              </div>
              <div
                ref={ref7}
                className={`${css.rightitem} ${
                  tabIndex === 7 ? css.select : ""
                }`}
                onClick={() => setTabIndex(7)}
              >
                <div className={css.title}>1996-1997</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs33")}</div>
                  <div className={css.details}>{t("$singlee_hs34")}</div>
                  <div className={css.details}>{t("$singlee_hs35")}</div>
                  <div className={css.details}>{t("$singlee_hs36")}</div>
                  <div className={css.details}>{t("$singlee_hs37")}</div>
                </div>
              </div>
              <div
                ref={ref8}
                className={`${css.rightitem} ${
                  tabIndex === 8 ? css.select : ""
                }`}
                onClick={() => setTabIndex(8)}
              >
                <div className={css.title}>1994-1995</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs38")}</div>
                  <div className={css.details}>{t("$singlee_hs39")}</div>
                  <div className={css.details}>{t("$singlee_hs40")}</div>
                </div>
              </div>
              <div
                ref={ref9}
                className={`${css.rightitem} ${
                  tabIndex === 9 ? css.select : ""
                }`}
                onClick={() => setTabIndex(9)}
              >
                <div className={css.title}>1992-1993</div>
                <div className={css.content}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <div className={css.details}>{t("$singlee_hs41")}</div>
                      <div className={css.details}>{t("$singlee_hs42")}</div>
                    </div>
                    <div className={css.rightImg}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={css.scroll}>
            <div className={css.left}>
              <div
                className={`${css.leftitem} ${
                  tabIndex === 0 ? css.select : ""
                }`}
                onClick={() => setTabIndex(0)}
                style={{ top: `${getTop(0)}px` }}
              >
                <div className={css.title}>{t("2021-至今")}</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs1")}</div>
                  <div className={css.details}>{t("$singlee_hs2")}</div>
                  {i18n.language === "zh" ? (
                    <>
                      <div className={css.details}>{t("$singlee_hs3")}</div>
                      <div className={css.details}>{t("$singlee_hs4")}</div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className={css.details}>{t("$singlee_hs5")}</div>
                  <div className={css.details}>{t("$singlee_hs6")}</div>
                  <div className={css.details}>{t("$singlee_hs7")}</div>
                  <div className={css.details}>{t("$singlee_hs8")}</div>
                  {i18n.language === "zh" ? (
                    <div className={css.details}>{t("$singlee_hs9")}</div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div
                className={`${css.leftitem} ${
                  tabIndex === 2 ? css.select : ""
                }`}
                onClick={() => setTabIndex(2)}
                style={{ top: `${getTop(2)}px` }}
              >
                <div className={css.title}>2015-2017</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs15")}</div>
                  <div className={css.details}>{t("$singlee_hs16")}</div>
                  <div className={css.details}>{t("$singlee_hs17")}</div>
                </div>
              </div>
              <div
                className={`${css.leftitem} ${
                  tabIndex === 4 ? css.select : ""
                }`}
                onClick={() => setTabIndex(4)}
                style={{ top: `${getTop(4)}px` }}
              >
                <div className={css.title}>2004-2007</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs22")}</div>
                  <div className={css.details}>{t("$singlee_hs23")}</div>
                  <div className={css.details}>{t("$singlee_hs24")}</div>
                </div>
              </div>
              <div
                className={`${css.leftitem} ${
                  tabIndex === 6 ? css.select : ""
                }`}
                onClick={() => setTabIndex(6)}
                style={{ top: `${getTop(6)}px` }}
              >
                <div className={css.title}>1998-1999</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs29")}</div>
                  <div className={css.details}>{t("$singlee_hs30")}</div>
                  <div className={css.details}>{t("$singlee_hs31")}</div>
                  <div className={css.details}>{t("$singlee_hs32")}</div>
                </div>
              </div>
              <div
                className={`${css.leftitem} ${
                  tabIndex === 8 ? css.select : ""
                }`}
                onClick={() => setTabIndex(8)}
                style={{ top: `${getTop(8)}px` }}
              >
                <div className={css.title}>1994-1995</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs38")}</div>
                  <div className={css.details}>{t("$singlee_hs39")}</div>
                  <div className={css.details}>{t("$singlee_hs40")}</div>
                </div>
              </div>
            </div>
            <div className={css.mid}>
              <div className={css.vert}>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>{t("至今")}</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2021</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2020</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2018</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2017</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2015</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2014</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2008</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2007</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2004</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2003</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>2000</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1999</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1998</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1997</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1996</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1995</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1994</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1993</div>
                </div>
                <div className={css.item}>
                  <div className={css.circle}></div>
                  <div className={css.text}>1992</div>
                </div>
              </div>
            </div>
            <div className={css.right}>
              <div
                className={`${css.rightitem} ${
                  tabIndex === 1 ? css.select : ""
                }`}
                onClick={() => setTabIndex(1)}
                style={{ top: `${getTop(1)}px` }}
              >
                <div className={css.title}>2018-2020</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs10")}</div>
                  <div className={css.details}>{t("$singlee_hs11")}</div>
                  <div className={css.details}>{t("$singlee_hs12")}</div>
                  <div className={css.details}>{t("$singlee_hs13")}</div>
                  <div className={css.details}>{t("$singlee_hs14")}</div>
                </div>
              </div>
              <div
                className={`${css.rightitem} ${
                  tabIndex === 3 ? css.select : ""
                }`}
                onClick={() => setTabIndex(3)}
                style={{ top: `${getTop(3)}px` }}
              >
                <div className={css.title}>2008-2014</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs18")}</div>
                  <div className={css.details}>{t("$singlee_hs19")}</div>
                  <div className={css.details}>{t("$singlee_hs20")}</div>
                  <div className={css.details}>{t("$singlee_hs21")}</div>
                </div>
              </div>
              <div
                className={`${css.rightitem} ${
                  tabIndex === 5 ? css.select : ""
                }`}
                onClick={() => setTabIndex(5)}
                style={{ top: `${getTop(5)}px` }}
              >
                <div className={css.title}>2000-2003</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs25")}</div>
                  <div className={css.details}>{t("$singlee_hs26")}</div>
                  <div className={css.details}>{t("$singlee_hs27")}</div>
                  <div className={css.details}>{t("$singlee_hs28")}</div>
                </div>
              </div>
              <div
                className={`${css.rightitem} ${
                  tabIndex === 7 ? css.select : ""
                }`}
                onClick={() => setTabIndex(7)}
                style={{ top: `${getTop(7)}px` }}
              >
                <div className={css.title}>1996-1997</div>
                <div className={css.content}>
                  <div className={css.details}>{t("$singlee_hs33")}</div>
                  <div className={css.details}>{t("$singlee_hs34")}</div>
                  <div className={css.details}>{t("$singlee_hs35")}</div>
                  <div className={css.details}>{t("$singlee_hs36")}</div>
                  <div className={css.details}>{t("$singlee_hs37")}</div>
                </div>
              </div>
              <div
                className={`${css.rightitem} ${
                  tabIndex === 9 ? css.select : ""
                }`}
                onClick={() => setTabIndex(9)}
                style={{ top: `${getTop(9)}px` }}
              >
                <div className={css.title}>1992-1993</div>
                <div className={css.content}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <div className={css.details}>{t("$singlee_hs41")}</div>
                      <div className={css.details}>{t("$singlee_hs42")}</div>
                    </div>
                    <div
                      className={css.rightImg}
                      style={{
                        width: i18n.language === "zh" ? "180px" : "0",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(Index);
